import { cn } from "@/lib/cn";

interface SpinnerProps {
  className?: string;
  label?: string;
}

export function Spinner({ className, label = "Loading" }: SpinnerProps) {
  return (
    <div
      className={cn(
        "flex items-center justify-center gap-3 text-sm text-[var(--color-text-muted)]",
        className,
      )}
    >
      <span
        className="h-4 w-4 animate-spin rounded-full border-2 border-[var(--color-border)] border-t-[var(--color-accent)]"
        aria-hidden
      />
      <span>{label}</span>
    </div>
  );
}
